import axios from "axios";
import { config } from "../../config";
import { LocalStorage } from "../../data/localstorage";

import { Configuration } from "../../entity/configuration";
import { ConfigurationTransformer } from '../transformers/configuration';

export class ConfigurationService {
    async configuration(): Promise<Configuration> {
        let response = await axios.get(config.api.host + "/config", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return new ConfigurationTransformer().transform(response.data.data)
    }
}